import React, { useRef, useState, useEffect } from 'react'

// import LazyLoad from 'react-lazy-load'
import { useSelector, shallowEqual } from 'react-redux'
import { Redirect } from 'react-router-dom'
import styled from 'styled-components'

import { SimpleCarousel } from '.'
import { useEventListener, useWindowSize } from '../../_helpers'
import {
    Container,
    Meta,
    Title,
    devices,
    colors,
} from '../Common'

const ImageCard = ({ image, openModal }) => {
    const [spans, setSpans] = useState(0)
    const imageRef = useRef()

    const setSpan = () => {
        const height = imageRef.current.clientHeight
        const spans = Math.ceil(height / (image.orientation === 'landscape' ? 15 : 16))
        setSpans(spans)
    }

    useEffect(setSpan, [])
    useEventListener('resize', setSpan)
    useEventListener('load', setSpan)

    return (
        <ImageContainer spans={spans}>
            <img ref={imageRef} src={image.image} alt={image.alt_text} onClick={openModal} />
        </ImageContainer>
    )
}


const PageView = () => {
    const { page, notFound } = useSelector(state => state.content, shallowEqual)
    const { gallery, title } = page
    const [showLightBox, setShowLightBox] = useState(false)
    const [activeSlide, setactiveSlide] = useState(0)
    const { width } = useWindowSize()
    const mobile = width < 480

    if (notFound) return <Redirect to='/' />

    const openModal = (i) => {
        setactiveSlide(i)
        setShowLightBox(true)
    }

    const closeModal = () => setShowLightBox(false)

    useEffect(closeModal, [page])

    return (
        <>
            <Meta page={page} />
            <PageContainer>
                {gallery ?
                    showLightBox ?
                        <SimpleCarousel title={title} slides={gallery} close={closeModal} activeImage={activeSlide} />
                        :
                        <>
                            <Title fontSize={mobile ? 14 : 16}>{title}</Title>
                            <ImageList>
                                {gallery.map((image, i) => <ImageCard key={i} image={image} openModal={() => openModal(i)} />)}
                            </ImageList>
                        </>
                    : ''}
            </PageContainer>
        </>
    )
}

const PageContainer = styled(Container)`
    min-height: 100vh;
    background: ${colors.black};
    padding: 50px;

    @media ${devices.small} {
        min-height: calc(100vh - 90px);
        padding: 20px;
    }
`

const ImageList = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(30%, 1fr));
    justify-content: space-evenly;
    grid-gap: 1rem;

    img {
        width: 93%;
        border: 10px solid white;
        cursor: pointer;
    }

    @media ${devices.small} {
        grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
        grid-gap: 5px;

        img {
            border-width: 3px;
        }
    }
`

const ImageContainer = styled.div`
    grid-row-end: span ${({ spans }) => spans};
`

export default PageView
